import axios from 'axios';// 它是一个HTTP工具，用于与后端进行数据交互。
import { i18n } from '../i18n/index.js';
import Vue from 'vue';
import { logout } from '@/utils/api/login.js';
import router from '@/router/index.js';
import { getOemConfig, watchOemConfig, clearLocalStorageExceptOemConfig } from './oemConfig.js';

// 生产环境
// 测试环境
// 开发环境
const baseURL = process.env.VUE_APP_URL;
// 要是跨域的话，就请求本地服务器跳转到vue.config.js解决跨域问题

// c创建一个axios实例
const instance = axios.create({
  baseURL,
  timeout: 15000,
  headers: {},
});

// 全局变量存储当前的 tenantId
let currentTenantId = '324566'; // 默认值

// 更新 tenantId 的函数
function updateTenantId(newTenantId) {
  if (newTenantId && newTenantId !== currentTenantId) {
    currentTenantId = newTenantId;
  }
}

// 获取当前 tenantId 的函数
function getCurrentTenantId() {
  return currentTenantId;
}

// 初始化时获取 oemConfig 中的 tenantId
try {
  const oemConfig = getOemConfig();
  if (oemConfig && oemConfig.tenantId) {
    currentTenantId = oemConfig.tenantId;
  }
} catch (error) {
  console.warn('初始化时获取 oemConfig 失败:', error);
}

// 监听 oemConfig 变化，自动更新 tenantId
try {
  watchOemConfig((newConfig) => {
    if (newConfig && newConfig.tenantId) {
      updateTenantId(newConfig.tenantId);
    }
  });
} catch (error) {
  console.warn('监听 oemConfig 变化失败:', error);
}

// 封装请求拦截器
instance.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  // 判断是否存在token,如果存在将每个页面header添加token
  
  // 使用当前存储的 tenantId
  config.headers.tenantId = currentTenantId;
  
  const time = (0 - new Date().getTimezoneOffset() / 60)
  if(time > 0){
    config.headers.TIMEZONE = '+' + time
  } else {
    config.headers.TIMEZONE = '' + time
  }
  if (localStorage.getItem('token')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  } else if (localStorage.getItem('token')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  }
  // 对应国际化资源文件后缀
  if(i18n.locale === 'en'){
    config.headers['Content-Language'] = 'en_US';
  } else if(i18n.locale === 'zh'){
    config.headers['Content-Language'] = 'zh_CN';
  }
  return config
}, function (error) {
  // this.$router.push('/login')
  return Promise.reject(error)
})


// 封装响应拦截器
instance.interceptors.response.use(
  (res) => {
    const code = res.data.code;
    const msg = res.data.msg;
    if(code === 401){
      Vue.prototype.$message({ message: '无效的会话，或者会话已过期，请重新登录。', type: 'error', duration: 2 * 1000 });
      logout().then(res=>{
        if(res.data.code == 200){
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
          if(userInfo?.userType == 'tch_user'){
            // 安全清除 localStorage，保留 oemConfig
            clearLocalStorageExceptOemConfig();
            router.push('/')
          }else{
            // 安全清除 localStorage，保留 oemConfig
            clearLocalStorageExceptOemConfig();
            router.push('/stuLogin')
          }
          
        }
      })
      return Promise.reject(res);
    }
    if (code !== 200) {
      Vue.prototype.$message({ message: msg, type: 'error', duration: 2 * 1000 });
      
      return Promise.reject(res);
    }
    return Promise.resolve(res);
  }, 
  (error) => {
    let { message } = error;
    if (message == 'Network Error') {
      message = '后端接口连接异常';
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时';
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常';
    }
    Vue.prototype.$message({ message: message, type: 'error', duration: 2 * 1000 });
    return Promise.reject(error);
  }
);

// 添加调试信息
console.log('https.js 已加载，当前 tenantId:', currentTenantId);

// 导出实例和工具函数
export { instance as default, updateTenantId, getCurrentTenantId };


